/*eslint-disable*/
import * as types from './../mutation-types';

const state = {
    intermediateBattleStage: null,
    battle: null,
    invitation: null,
    isInvitationDeclined: false,
    isBattleAccepted: false,
    isBattlePaused: false,
};

const mutations = {
    [types.SET_INTERMEDIATE_BATTLE_STAGE](state, intermediateStage) {
        state.intermediateBattleStage = intermediateStage;
    },
    [types.SET_BATTLE](state, battle) {
        state.battle = battle
    },
    [types.SET_BATTLE_INVITATION](state, invitation) {
        state.invitation = invitation;
    },
    [types.SET_BATTLE_DECLINED](state, value) {
        state.isInvitationDeclined = value;
    },
    [types.SET_BATTLE_ACCEPTED](state, value) {
        state.isBattleAccepted = value;
    },
    [types.SET_BATTLE_PAUSED](state, value) {
        state.isBattlePaused = value;
    },
};

const actions = {
    setBattle({commit, state}, battle) {
        commit(types.SET_BATTLE, battle);
    },
    setIntermediateBattleStage({commit, state}, intermediateStage) {
        commit(types.SET_INTERMEDIATE_BATTLE_STAGE, intermediateStage);
    },
    setBattleInvitation({commit, state}, invitation) {
        commit(types.SET_BATTLE_INVITATION, invitation);
    },
    setBattleDeclined({commit, state}, value) {
        commit(types.SET_BATTLE_DECLINED, value);
    },
    setBattleAccepted({commit, state}, value) {
        commit(types.SET_BATTLE_ACCEPTED, value);
    },
    setBattlePaused({commit, state}, value) {
        commit(types.SET_BATTLE_PAUSED, value);
    },
};

export default {
    state,
    mutations,
    actions
}
